import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/lib/api";
import { apiErrorMessage } from "@/lib/formHelpers";

export const useTipCheckout = (selected, source) => {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const payCard = async () => {
    if (loading || !selected) return;
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/payments/checkout`, {
        lookup_key: selected.lookup_key, origin_url: window.location.origin,
        donor_name: name.trim() || null, source: source || "site",
      });
      window.location.assign(data.checkout_url);
    } catch (error) {
      toast.error(apiErrorMessage(error, "Paiement indisponible pour le moment, réessaie"));
    } finally { setLoading(false); }
  };
  return { name, setName, loading, payCard };
};